import React, { Component } from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';
import {Link} from "react-router-dom";

class WNavBar extends Component {
    render() {
        return <Navbar bg="dark" variant="dark" style={{'font-size': '1.2rem'}} >
            <Container className="justify-content-between">
                <Navbar.Brand inline href="/" style={{'font-size': '1.6rem'}}>RiskTails</Navbar.Brand>
                <Nav inline>
                    {/*<Link to="/" className="nav-link">Home</Link>*/}
                    {/*<Link to="/about" className="nav-link">About</Link>*/}
                    {/*<Link to="/contact" className="nav-link">Contact</Link>*/}
                </Nav>
            </Container>
        </Navbar>;
    }
}
export default WNavBar;
